import { TmcContextService } from './../../../../common/tmc-context.service';
import { StructureSelection, StructureSelectionRequest, StructureSelectionScope } from './../../../../common/structure-selection/structure-selection.model';

import { Component, Inject } from '@angular/core';
import { StationGroup } from '../../../../client/model/station-group';
import { TranslationService } from '@sdbn/common';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DictionaryKeySelectOption } from '@sdbn/common';
import { ForwardToStationSelectionResult } from '../model/forward-to-station.model';
import { AppClientConfigurationService } from '@sdbn/common';
import { StationType } from '../../../../client/model/station-type.enum';

@Component({
    selector: 'app-forward-to-station-dialog',
    templateUrl: './forward-to-station.component.html',
    styleUrls: ['./forward-to-station.component.scss'],
    standalone: false
})
export class ForwardToStationStructureSelectionDialogComponent {


  stationGroups: Array<StationGroup>;

  selectedStationGroup: StationGroup = null;

  selectionValid = false;

  selection: StructureSelection;

  selectedOption: DictionaryKeySelectOption;

  constructor(
    public configurationService: AppClientConfigurationService,
    public translationService: TranslationService,
    private tmcContextService: TmcContextService,
    private dialog: MatDialogRef<ForwardToStationStructureSelectionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public request: StructureSelectionRequest,
  ) {

  //   data.validation$.subscribe(validation => {

  //     // TODO

  //     if (this.data.selection.stationId != null) {
  //       const station = tmcContextService.findStationById(this.data.selection.stationId);
  //       if ((station?.stationType === StationType.WORKING_AREA && station?.stationUsage?.transports?.length > 0)
  //         || station?.stationUsage?.suspended
  //         || station?.stationUsage?.disabled) {
  //         console.log('station is occupied/suspended/disabled. Selection is invalid');
  //         this.selectionValid = false;
  //       } else {
  //         this.selectionValid = validation;
  //       }
  //     } else {
  //       this.selectionValid = validation;
  //     }
  //   });
  }

  public optionsChanged(event: DictionaryKeySelectOption) {
    this.selectedOption = event;
  }

  // onSelectionChanged(entry: MasterDetailListEntry) {
  //   const stationGroup = entry as StationGroup;
  //   this.data.setStationGroupSelection(stationGroup.id);
  // }

  confirmDialog() {
    const result = new ForwardToStationSelectionResult();
    result.reasonOptionDictionaryKey = this.selectedOption == null ? null : this.selectedOption.dictionaryKey;
    result.stationGroupId = this.selection.stationGroupId;
    result.stationSetId = this.selection.stationSetId;
    result.stationId = this.selection.stationId;
    this.dialog.close(this.selection);
  }

  cancelDialog() {
    this.dialog.close(null);
  }

  handleSelectionChanged(selection: StructureSelection) {

    this.selection = selection;

    if (selection.stationId != null) {
        const station = this.tmcContextService.findStationById(selection.stationId);
        if ((station?.stationType === StationType.WORKING_AREA && station?.stationUsage?.transports?.length > 0)
          || station?.stationUsage?.suspended
          || station?.stationUsage?.disabled) {
          console.log('station is occupied/suspended/disabled. Selection is invalid');
          this.selectionValid = false;
        } else {
          this.selectionValid = selection.valid;
        }
      } else {
        this.selectionValid = selection.valid;
      }

  }


}
